import TruncateText from './truncate-text';

export default TruncateText;
